export default "__VITE_ASSET__GhC2qoUa__"